<rxap-window-container>
  <rxap-window-content></rxap-window-content>
</rxap-window-container>
